import * as yup from 'yup';

export const userSchema = yup.object({
  name: yup
    .string()
    .required('Имя обязательно для заполнения')
    .min(2, 'Имя должно содержать минимум 2 символа')
    .max(50, 'Имя не должно превышать 50 символов'),
  email: yup
    .string()
    .required('Email обязателен для заполнения')
    .email('Введите корректный email адрес'),
  phone: yup
    .string()
    .matches(/^[\+]?[1-9][\d]{0,15}$/, 'Введите корректный номер телефона'),
  age: yup
    .number()
    .positive('Возраст должен быть положительным числом')
    .integer('Возраст должен быть целым числом')
    .min(18, 'Минимальный возраст 18 лет')
    .max(120, 'Максимальный возраст 120 лет'),
  password: yup
    .string()
    .required('Пароль обязателен для заполнения')
    .min(8, 'Пароль должен содержать минимум 8 символов')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
      'Пароль должен содержать минимум одну строчную букву, одну заглавную букву и одну цифру',
    ),
  confirmPassword: yup
    .string()
    .required('Подтверждение пароля обязательно')
    .oneOf([yup.ref('password')], 'Пароли не совпадают'),
});

export const loginSchema = yup.object({
  email: yup
    .string()
    .required('Email обязателен для заполнения')
    .email('Введите корректный email адрес'),
  password: yup
    .string()
    .required('Пароль обязателен для заполнения')
    .min(6, 'Пароль должен содержать минимум 6 символов'),
  rememberMe: yup.boolean(),
});

export const contactSchema = yup.object({
  name: yup
    .string()
    .required('Имя обязательно для заполнения')
    .min(2, 'Имя должно содержать минимум 2 символа'),
  email: yup
    .string()
    .required('Email обязателен для заполнения')
    .email('Введите корректный email адрес'),
  subject: yup
    .string()
    .required('Тема обязательна для заполнения')
    .min(5, 'Тема должна содержать минимум 5 символов'),
  message: yup
    .string()
    .required('Сообщение обязательно для заполнения')
    .min(10, 'Сообщение должно содержать минимум 10 символов')
    .max(1000, 'Сообщение не должно превышать 1000 символов'),
});

export type UserFormData = yup.InferType<typeof userSchema>;
export type LoginFormData = yup.InferType<typeof loginSchema>;
export type ContactFormData = yup.InferType<typeof contactSchema>;
